import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type { ITrackEvent } from '~/routes/api.track-event.query/route';
import type * as Types from 'app/types/graphql';

import { fetchFromAPI } from '~/api/utils';

export type TrackingEventMutationVariables = Types.Exact<{
  inputs: ITrackEvent;
}>;

export type TrackingEventMutationResponse = {
  message: string;
};

export const useTrackingEventMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TrackingEventMutationResponse,
    TError,
    TrackingEventMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TrackingEventMutationResponse,
    TError,
    TrackingEventMutationVariables,
    TContext
  >(
    ['trackingEvent'],
    (variables?: TrackingEventMutationVariables) =>
      fetchFromAPI(`/api/track-event/query`, {
        method: 'POST',
        body: JSON.stringify({
          variables: variables,
        }),
      }),
    options,
  );
};

useTrackingEventMutation.getKey = () => ['trackingEvent'];
